import type { FileUsage } from '@vedalib/editor/lib/files'
import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IFileLoaderProps } from 'components/uiKit/FileLoader'
import FileLoader from 'components/uiKit/FileLoader'

const FieldFile = <V extends FileUsage | null>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IFileLoaderProps<V>, V>) => {
  const handleChange = useCallback((value: V) => onChange({ name, value }), [name, onChange])

  return <FileLoader {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldFile) as typeof FieldFile
